// Crisp Chat Configuration
document.addEventListener("DOMContentLoaded", function() {
  // Wait for Crisp to be ready
  window.addEventListener("load", function() {
    // Bail out unless the page actually ships Crisp. The book layout emits
    // neither the crisp-website-id meta nor the Crisp snippet, so reading
    // .content off the missing tag threw a TypeError on every page using that
    // layout (all of /v2/sequences included) and killed the rest of this
    // handler with it.
    var websiteId = document.querySelector('meta[name="crisp-website-id"]');
    if (!websiteId || typeof window.$crisp === "undefined") return;

    // Set Crisp Website ID from credentials
    window.CRISP_WEBSITE_ID = websiteId.content;

    // Optional: Set custom colors to match your site's theme
    $crisp.push(["do", "color:setTheme", "maroon"]); // Using your site's maroon color from CSS

    // Optional: Set custom welcome message
    $crisp.push(["do", "message:set", "text", ["Hello! How can we help you today?"]]);

    // Optional: Set custom avatar for the chat
    $crisp.push(["do", "user:setAvatar", "https://your-domain.com/path-to-avatar.png"]);

    // Optional: Set custom nickname for the chat
    $crisp.push(["do", "user:setNickname", "Support Team"]);
  });
});
